<template>
  <div class="container-fluid py-3 px-4">

    <!-- BOTÓN REGRESAR -->
    <div class="mb-3">
      <button class="btn btn-danger" @click="regresar">
        <i class="bi bi-skip-backward fs-5 me-1"></i>
      </button>
    </div>

    <!-- TÍTULO -->
     <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-person-vcard fs-1 me-2"></i>
        <div>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            USUARIO
          </p>
        </div>
      </div>
    </div>
   

    <div class="card shadow-sm mb-4 border-3">
      
      <div class="card-body">
        <div class="row g-3">

          <div class="col-12 col-md-1">
            <label class=" d-flex align-items-center gap-2 tamaño">
              <i class="bi bi-person-badge fs-5 text-primary "></i> ID
            </label>
            <input class="form-control form-control-sm" :value="info.idPostulante" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class=" d-flex align-items-center gap-2 tamaño">
              <i class="bi bi-person fs-5 text-success"></i> NOMBRE Y APELLIDO
            </label>
            <input class="form-control form-control-sm"
              :value="info.posNombre + ' ' + info.posApePaterno + ' ' + info.posApeMaterno" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-file-earmark-text fs-5 text-info"></i> TIPO DE DOCUMENTO
            </label>
            <input class="form-control form-control-sm" :value="info.desTipDocumento" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-credit-card-2-front fs-5 text-secondary"></i> Nº DOCUMENTO
            </label>
            <input class="form-control form-control-sm" :value="info.posNroDocumento" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-gender-ambiguous fs-5 text-warning"></i> GENERO
            </label>
            <input class="form-control form-control-sm" :value="info.desGenero" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-calendar-event fs-5 text-danger"></i> FECHA DE NACIMIENTO
            </label>
            <input type="date" class="form-control form-control-sm"
              :value="info.posFecNacimiento && info.posFecNacimiento.slice(0, 10)" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-check2-circle fs-5 text-success"></i> ESTADO
            </label>
            <input class="form-control form-control-sm" :value="info.desEstado" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-envelope-at fs-5 text-secondary"></i> CORREO
            </label>
            <input type="email" class="form-control form-control-sm" :value="info.posCorreo" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-envelope-check fs-5 text-success"></i> CORREO ENVIADO
            </label>
            <input class="form-control form-control-sm" :value="info.posCorreoEnviado" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-telephone fs-5 text-info"></i> CELULAR
            </label>
            <input class="form-control form-control-sm" :value="info.posTelefono" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-telephone-plus fs-5 text-success"></i> TELEFONO ADICIONAL
            </label>
            <input class="form-control form-control-sm" :value="info.posTelAdicional" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-house-door fs-5 text-primary"></i> DIRECCION
            </label>
            <input class="form-control form-control-sm" :value="info.posDireccion" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-geo fs-5 text-danger"></i> POS PAIS
            </label>
            <input class="form-control form-control-sm" :value="info.posPais" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-globe-americas fs-5 text-primary"></i> PAIS
            </label>
            <input class="form-control form-control-sm" :value="info.desPais" disabled />
          </div>

          <div class="col-12 col-md-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-flag fs-5 text-warning"></i> NACIONALIDAD
            </label>
            <input class="form-control form-control-sm" :value="info.desNacionalidad" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-map fs-5 text-info"></i> UBIGEO
            </label>
            <input class="form-control form-control-sm" :value="info.posUbigeo" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-mortarboard fs-5 text-warning"></i> GRADO ACADEMICO
            </label>
            <input class="form-control form-control-sm" :value="info.desGradoAcademico" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person-workspace fs-5 text-primary"></i> OCUPACION
            </label>
            <input class="form-control form-control-sm" :value="info.posOcupacion" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-briefcase fs-5 text-secondary"></i> PERFIL PROFESIONAL
            </label>
            <input class="form-control form-control-sm" :value="info.posPerProfesional" disabled />

          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-journal-bookmark fs-5 text-success"></i> ESTUDIOS
            </label>
            <input class="form-control form-control-sm" :value="info.posEstudios" disabled />

          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-people fs-5 text-primary"></i> CANTIDAD HIJOS
            </label>
            <input class="form-control form-control-sm" :value="info.posCanHijos" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-emoji-smile fs-5 text-warning"></i> HIJOS MENORES
            </label>
            <input class="form-control form-control-sm" :value="info.posHijosMen" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-gender-ambiguous fs-5 text-secondary"></i> POS GENERO
            </label>
            <input class="form-control form-control-sm" :value="info.posGenero" disabled />
          </div>

          <div class="col-12 col-md-3">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-flag fs-5 text-danger"></i> NACIONALIDAD EXTRA
            </label>
            <input class="form-control form-control-sm" :value="info.posNacionalidad" disabled />
          </div>

          <div class="col-12 col-md-4">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-clipboard-check fs-5 text-success"></i> ESTADO CONVOCATORIA
            </label>
            <input class="form-control form-control-sm" :value="info.postEstadoConvoca" disabled />
          </div>

          <div class="col-12 col-md-4">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person-check fs-5 text-primary"></i> USUARIO CREADO
            </label>
            <input class="form-control form-control-sm" :value="info.posUsuCreado" disabled />
          </div>

          <div class="col-12 col-md-4">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-info-circle fs-5 text-secondary"></i> DATOS
            </label>
            <input class="form-control form-control-sm" :value="info.posDatos" disabled />

          </div>

          <div class="col-12 col-md-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-paperclip fs-5 text-info"></i> ADJUNTO
            </label>
            <input class="form-control form-control-sm" :value="info.posAdjunto" disabled />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>




<script>
export default {
  name: "SolimanologUsuarioInfoComplete",

  data() {
    return {
      IdPostulante: "",
      info: [],
    };
  },
  mounted() {
    this.idPostulante = this.$route.params.id;
    this.axios
      .get("Postulante/ObtenerPostulante/" + this.idPostulante)
      .then((datos) => {
        this.info = datos.data;
        console.log(datos.data);
      });
  },

  methods: {
    regresar() {
      this.$router.push("/listado");
    },
  },
};
</script>

<style scoped>
.tamaño {
  font-size: 0.70rem;

  font-weight: 800;
  color: #002c5d;
}
</style>
